'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTiles = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _CardProductTiles = require('acq-components/lib/composite-components/ProductTiles/CardProductTiles');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _stylesheet = require('../../routes/ViewAllCardsBusiness/au/stylesheet');

var _cardTiles = require('../../redux/selectors/cardTiles');

var selectors = _interopRequireWildcard(_cardTiles);

var _cardTileProps = require('./cardTileProps');

var _ApplyModal = require('../ApplyModal/ApplyModal');

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardTiles = function CardTiles(_ref) {
  var styles = _ref.styles,
      _ref$cardTitleTag = _ref.cardTitleTag,
      cardTitleTag = _ref$cardTitleTag === undefined ? 'h3' : _ref$cardTitleTag,
      _ref$titleTag = _ref.titleTag,
      titleTag = _ref$titleTag === undefined ? 'h1' : _ref$titleTag,
      namespace = _ref.namespace,
      shadeAlternator = _ref.shadeAlternator,
      custClassName = _ref.custClassName,
      isProducts = _ref.isProducts,
      dtmHelper = _ref.dtmHelper,
      qeId = _ref.qeId,
      collapsableOnMobile = _ref.collapsableOnMobile,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'cardTitleTag', 'titleTag', 'namespace', 'shadeAlternator', 'custClassName', 'isProducts', 'dtmHelper', 'qeId', 'collapsableOnMobile']);

  var _useState = (0, _react.useState)({ show: false, cardName: '' }),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  var openModal = function openModal(cardName) {
    return setModalState({ show: true, cardName: cardName });
  };
  var closeModal = function closeModal() {
    return setModalState({ show: false, cardName: '' });
  };

  var units = isProducts ? props.products : props.cards;
  var title = isProducts ? props.productTitle : props.cardTitle;
  var cardTilesPropFactory = (0, _cardTileProps.getCardTilesPropFactory)(units, props.intlPage, cardTitleTag, styles.cardProductStyles, dtmHelper, openModal);

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded(),
      custClassName: custClassName
    },
    _react2.default.createElement(_CardProductTiles.CardProductTiles, {
      products: cardTilesPropFactory.products,
      Component: 'div',
      styles: styles.cardProductStyles,
      title: _react2.default.createElement(_Sanitizer.Sanitizer, { Component: titleTag, safelySetInnerHTML: title }),
      namespace: namespace,
      qeId: qeId,
      collapsableOnMobile: collapsableOnMobile
    }),
    modalState.show && _react2.default.createElement(_ApplyModal2.default, {
      styles: styles,
      cardName: modalState.cardName,
      closeModal: closeModal,
      dtmHelper: dtmHelper
    })
  );
};

exports.CardTiles = CardTiles;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var isProducts = ownProps.isProducts,
      collapsableOnMobile = ownProps.collapsableOnMobile;


  return {
    cardTitle: selectors.getCardTitle(state),
    productTitle: selectors.getProductTitle(state),
    cards: selectors.getCards(state),
    products: selectors.getProducts(state),
    intlPage: state.intlPage,
    qeId: isProducts ? selectors.getProductTileQeId(state) : selectors.getCardTileQeId(state),
    collapsableOnMobile: collapsableOnMobile || false
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CardTiles);